"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var feature_flipper_1 = require("../../../../shared/constants/feature-flipper");
var environment_1 = require("../../../../shared/types/environment");
// TODO: Add types
var SingleDisplayLogicController = /** @class */ (function () {
    function SingleDisplayLogicController($filter, 
    // @ts-ignore
    Filters, 
    // @ts-ignore
    fieldsets, 
    // @ts-ignore
    displayLogicConstants, 
    // @ts-ignore
    displayLogicService, 
    // @ts-ignore
    env, 
    // @ts-ignore
    relationshipMenuService, 
    // @ts-ignore
    personService) {
        this.$filter = $filter;
        this.Filters = Filters;
        this.fieldsets = fieldsets;
        this.displayLogicConstants = displayLogicConstants;
        this.displayLogicService = displayLogicService;
        this.env = env;
        this.relationshipMenuService = relationshipMenuService;
        this.personService = personService;
        this.QUESTION = 'Question';
        this.SCORING_CATEGORY = 'Scoring Category';
        this.RANKABLE_ITEMS = 'rankableItems';
        this.$ctrl = this;
        this.translate = this.$filter('translate');
        this.fieldsets = fieldsets;
        this.displayLogicConstants = displayLogicConstants;
        this.displayLogicService = displayLogicService;
        this.env = env;
        this.relationshipMenuService = relationshipMenuService;
        this.personService = personService;
        angular_1.extend(this.$ctrl, {
            $onInit: function () {
                this.CATEGORIES = this.displayLogicConstants.CATEGORIES;
                this.displayLogicObj = this.singleDisplayLogic.displayLogic;
                this.filterService = new Filters(this.sourceId);
                if (this.showCategoryOptions()) {
                    this.categoryOptions = this.displayLogicConstants.getCategoryOptions();
                    var featureFlippers = this.env.get(environment_1.ENV_VARS.FEATURES) || {};
                    if (featureFlippers[feature_flipper_1.FEATURES.DISPLAY_LOGIC_HIGHEST_LOWEST]) {
                        this.categoryOptions[this.RANKABLE_ITEMS] = this.translate('AWA.DATA_SOURCE_TYPE_RANKABLE_ITEMS');
                    }
                    // Add category to existing metric display logic if it did not exist
                    if (!this.displayLogicObj.category && this.displayLogicObj.metric) {
                        this.displayLogicObj.category = this.CATEGORIES.METRIC;
                    }
                    this.initRelationshipLabel();
                }
                this.metricOptions = this.displayLogicConstants.getMetricOptions();
                this.comparatorOptions = this.displayLogicConstants.getRankableComparators();
            },
            showCategoryOptions: function () {
                return this.displayLogicService.shouldHave360DisplayLogic();
            },
            showRelationshipCategory: function () {
                return this.showCategoryOptions()
                    && this.displayLogicObj.category === this.CATEGORIES.RELATIONSHIP;
            },
            showMetricCategory: function () {
                return this.showCategoryOptions() ? this.displayLogicObj.category === this.CATEGORIES.METRIC : true;
            },
            getCategoryLabel: function () {
                var category = this.displayLogicObj.category;
                return category ? this.categoryOptions[category] : this.translate('PR.SELECT_CATEGORY');
            },
            getMetricLabel: function () {
                var metric = this.displayLogicObj.metric;
                return metric ? this.metricOptions[metric] : this.translate('SELECT_METRIC');
            },
            getFieldOptions: function () {
                var options = {
                    selected: this.displayLogicObj.field,
                    includeAllChoices: false,
                    filter: ['EnumerableScalarValue', 'ScalarValue'] // Only numeric fields are supported for now
                };
                return this.fieldsets.getFieldMenuBySurveyId(this.sourceId, options);
            },
            getFieldLabel: function () {
                var field = this.displayLogicObj.field;
                return field ? this.fieldsets.getFieldLabelById(this.sourceId, field) : this.translate('SELECT_FIELD');
            },
            getRelationshipOptions: function () {
                var self = this;
                // @ts-ignore
                return this.relationshipMenuService.getFormattedRelationships().then(function (items) {
                    lodash_1.default.forEach(items, function (item) {
                        item.selected = self.displayLogicObj.relationshipValue === item.value;
                    });
                    return items;
                });
            },
            // @ts-ignore
            setRelationship: function (item) {
                this.displayLogicObj.relationshipValue = item.value;
                this.relationshipLabel = item.label;
            },
            initRelationshipLabel: function () {
                if (!this.displayLogicObj.relationshipValue) {
                    return;
                }
                var self = this;
                // @ts-ignore
                this.relationshipMenuService.getFormattedRelationships().then(function (items) {
                    var selectedItem = lodash_1.default.find(items, {
                        value: self.displayLogicObj.relationshipValue
                    });
                    self.relationshipLabel = selectedItem.label;
                });
            },
            getRelationshipLabel: function () {
                var relationshipValue = this.displayLogicObj.relationshipValue;
                return relationshipValue ? this.relationshipLabel : this.translate('PR.SELECT_RELATIONSHIP');
            },
            getOperatorOptions: function () {
                return this.displayLogicConstants.getOperatorOptions(this.displayLogicObj.category);
            },
            getOperatorLabel: function () {
                var category = this.displayLogicObj.category;
                var operator = this.displayLogicObj.operator;
                if (category === this.CATEGORIES.RELATIONSHIP) {
                    operator = this.displayLogicObj.relationshipOperator;
                }
                else if (category === this.CATEGORIES.PERSON_METADATA) {
                    operator = this.displayLogicObj.personMetadataOperator;
                }
                else if (category === this.CATEGORIES.RANKABLE_ITEMS) {
                    operator = this.displayLogicObj.rankableOperator;
                }
                return operator ? this.getOperatorOptions()[operator] : this.translate('SELECT_OPERATOR');
            },
            // =======================
            // Person Metadata
            // =======================
            showPersonMetadataCategory: function () {
                return (this.showCategoryOptions() &&
                    this.displayLogicObj.category === this.CATEGORIES.PERSON_METADATA);
            },
            getPersonMetadataLabel: function () {
                var label = this.displayLogicObj.personMetadata;
                return label ? label : this.translate('PR.SELECT_METADATA');
            },
            getPersonMetadataOperandLabel: function () {
                var label = this.displayLogicObj.personMetadataLabel;
                return label ? label : this.translate('PR.SELECT_OPERAND');
            },
            getPersonMetadataFields: function () {
                var _this = this;
                var personMetadata = this.displayLogicObj.personMetadata;
                // @ts-ignore
                return this.personService.getMetadata().then(function (items) {
                    var formattedItems = _this.formatMenuItems(items);
                    lodash_1.default.forEach(formattedItems, function (item) {
                        item.selected = personMetadata === item.value;
                    });
                    return formattedItems;
                });
            },
            /**
             * Clear the operand once a different person metadata field is chosen
             */
            // @ts-ignore
            setPersonMetadataField: function (item) {
                this.displayLogicObj.personMetadata = item.value;
                delete this.displayLogicObj.operand;
                delete this.displayLogicObj.personMetadataLabel;
            },
            getPersonMetadataOperands: function () {
                var _this = this;
                var field = this.displayLogicObj.personMetadata;
                if (!field) {
                    return;
                }
                var operand = this.displayLogicObj.operand;
                // @ts-ignore
                return this.personService.getMetadataValues(field).then(function (items) {
                    var formattedItems = _this.formatMenuItems(items, field);
                    lodash_1.default.forEach(formattedItems, function (item) {
                        item.selected = operand === item.value;
                    });
                    return formattedItems;
                });
            },
            // @ts-ignore
            setPersonMetadataOperand: function (item) {
                this.displayLogicObj.personMetadataLabel = item.label;
                this.displayLogicObj.operand = item.value;
            },
            /**
             * Formats an array of strings into dropdown menu items for qstrap.menu
             */
            // @ts-ignore
            // @ts-ignore
            formatMenuItems: function (data, field) {
                var _this = this;
                var LANGUAGE = 'Language';
                return lodash_1.default.map(data, function (datum) {
                    return {
                        label: field === LANGUAGE ? _this.translateLanguageCode(datum) : datum,
                        value: datum,
                        selected: false
                    };
                });
            },
            // =======================
            // Rankable Items
            // =======================
            showRankableCategory: function () {
                return this.showCategoryOptions()
                    && this.displayLogicObj.category === this.CATEGORIES.RANKABLE_ITEMS;
            },
            getRankableTypes: function () {
                return this.displayLogicConstants.getRankableTypes();
            },
            getRankableLabel: function () {
                var rankableValue = this.displayLogicObj.rankableValue;
                return rankableValue || this.translate('AWA.SELECT_DATA_SOURCE');
            },
            // @ts-ignore
            setRankableType: function (item) {
                this.displayLogicObj.rankableValue = item;
            },
            isQuestionSelected: function () {
                return this.displayLogicObj.rankableValue === this.QUESTION;
            },
            getAllQuestions: function () {
                var options = {
                    selected: this.displayLogicObj.question,
                    includeAllChoices: false,
                    removeSurveyMetadata: true,
                    filter: ['EnumerableScalarValue', 'ScalarValue'] // Only numeric fields are supported for now
                };
                return this.fieldsets.getFieldMenuBySurveyId(this.sourceId, options);
            },
            getQuestionLabel: function () {
                var question = this.displayLogicObj.question;
                return question ? this.fieldsets.getFieldLabelById(this.sourceId, question) : this.translate('SELECT_FIELD');
            },
            isScoringCategorySelected: function () {
                return this.displayLogicObj.rankableValue === this.SCORING_CATEGORY;
            },
            getAllCategories: function () {
                var options = {
                    selected: this.displayLogicObj.categories,
                    includeAllChoices: false,
                    onlyCategories: true,
                    removeSurveyMetadata: true
                };
                return this.fieldsets.getFieldMenuBySurveyId(this.sourceId, options);
            },
            getScoringCategoryLabel: function () {
                var category = this.displayLogicObj.categories;
                return category ? this.fieldsets.getFieldLabelById(this.sourceId, category) : this.translate('SELECT_FIELD');
            },
            getRankableComparators: function () {
                return this.displayLogicConstants.getRankableComparators();
            },
            getRankableComparatorLabel: function () {
                var comparator = this.displayLogicObj.rankableComparator;
                return this.comparatorOptions[comparator] || this.translate('AWA.SELECT_OPERATOR_TYPE');
            },
            /**
             * Translates a language code into a readable language name
             */
            // @ts-ignore
            translateLanguageCode: function (languageCode) {
                var TRANSLATION_NAMESPACE = 'Language.';
                return this.translate(TRANSLATION_NAMESPACE + languageCode);
            }
        });
    }
    SingleDisplayLogicController.$inject = [
        '$filter',
        'prFilterService',
        'pr.fieldsets',
        'prDisplayLogicConstants',
        'prDisplayLogicService',
        'rsEnvironment',
        'prRelationshipMenuService',
        'pr.personService'
    ];
    return SingleDisplayLogicController;
}());
(function (angularModule) {
    angularModule.controller('prSingleDisplayLogicController', SingleDisplayLogicController);
})(angular_1.module('qualtrics.pr'));
